'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addId = function addId(data) {
  return data.map(function (item) {
    return _extends({}, item, {
      __id: _shortid2.default.generate()
    });
  });
};

exports.default = addId;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-table/lib/RpTable/helpers/addIds.js
// module id = 1003
// module chunks = 0